"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.2371 3h5.5258C19.8059 3 21 4.194 21 9.2371v5.5258C21 19.8059 19.8059 21 14.7629 21H9.2371C4.1941 21 3 19.8059 3 14.7629V9.2371C3 4.1941 4.194 3 9.2371 3z",
    fill: "#4680C2"
  }), _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7355 9.1995c.0889-.2795 0-.4827-.3938-.4827h-1.3084c-.3303 0-.4827.1778-.5716.3684 0 0-.6733 1.626-1.6133 2.6803-.3048.3049-.4446.4065-.6097.4065-.0889 0-.2033-.1016-.2033-.3811v-2.604c0-.3304-.1016-.4828-.3811-.4828h-2.0578c-.2033 0-.3303.1524-.3303.3049 0 .3175.47.3938.5208 1.283v1.9308c0 .4192-.0762.4954-.2413.4954-.4446 0-1.5244-1.6387-2.1722-3.506-.127-.3684-.254-.5081-.5844-.5081h-1.321c-.3811 0-.4447.1778-.4447.3684 0 .343.4446 2.0706 2.0706 4.3571 1.0798 1.5624 2.6168 2.4008 4.0014 2.4008.8384 0 .94-.1905.94-.5081v-1.1814c0-.381.0763-.4446.343-.4446.1906 0 .5335.1017 1.3084.8511.8892.8892 1.0416 1.2957 1.5371 1.2957h1.3084c.381 0 .5589-.1905.4573-.5589-.1144-.3684-.5463-.9019-1.1052-1.5371-.3049-.3556-.7622-.7494-.9019-.94-.1905-.254-.1397-.3556 0-.5843-.0127 0 1.5879-2.2611 1.753-3.0233z",
    fill: "#fff"
  })];
};

exports.default = _default;